import { render } from "./footer.vue?vue&type=template&id=2d78328a&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=2d78328a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2d78328a"

export default script